import { Pipe, PipeTransform } from '@angular/core';
import * as _ from 'lodash';

@Pipe({ name: 'slice' })
export class SlicePipe implements PipeTransform {

    constructor() {

    }

    transform(string, amount) {

        if (_.isUndefined(string)) {
            return "";
        } else {
            if (string.length <= amount) {
                return string;
            } else {
                return string.slice(0, amount) + '...';
            }
        }

    }
}